import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Challengetrip() {
  return (
    <section
      className="challenge_trip p-100 text_white"
      style={{ background: "#153669" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>
              Challenges & <span style={{ color: "#CCAB24" }}>Solutions</span>
            </h2>
            <p>
              The project was initially launched in KSA & UAE and later expanded
              to other parts of the globe, including Europe, America, and other
              locations. We had to build a custom architecture with the
              necessary features to provide a comprehensive, reliable digital
              payment solution with multiple currency support.
            </p>
            <p>
              Moreover, to make it usable by everyone, Apple Pay had to be
              integrated into the platform. Our experts devised a complete
              solution, ensuring seamless payment integration and allowing any
              party to use the system to transfer funds without hassle.
            </p>
            <p>
              Purpose-built for equine owners and transportation companies, the
              platform had all the features and functions to make it easier for
              them to transport horses safely to the desired destination and on
              schedule. We transformed the thought into a full-fledged system to
              help the equestrian transport industry find the course.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto text-center offset-xl-1 offset-lg-1"
          >
            <div className="challenge_trip_img">
              <StaticImage
                src="../../../images/case-studies/equi-trip/challenges_img_1.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={527}
                height={650}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Challengetrip;
